import React, { useEffect, useState } from 'react'
import Navbars from '../../../Components/Navbar'
import LoadingSpinner from '../../../Components/LoadingSpinner'
import * as XLSX from 'xlsx'
import { Form, Toast, Button } from 'react-bootstrap'
import uuid from 'react-uuid'
import './uploadStyle.css'
import firebaseConfig from '../../../Utilities/Firebase'
import { getDatabase, ref, set } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import { useNavigate } from 'react-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

function UploadData() {
  const [isLoading, setIsLoading] = useState(false)
  const [items, setItems] = useState([])
  const [show, setShow] = useState(false)
  const [showError, setShowError] = useState(false)
  const [message, setMessage] = useState('')
  const [degree, setDegree] = useState('B Tech')
  const [course, setCourse] = useState('IT engineering')
  const [year, setYear] = useState('1')
  const navigate = useNavigate()

  useEffect(() => {
    IsUserLogedIn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig)
    const auth = getAuth(FirebaseApp)
    onAuthStateChanged(auth, user => {
      if (user === null) {
        navigate('/')
      }
    })
  }

  const readExcel = file => {
    setItems([])
    try {
      const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file)
        fileReader.onload = e => {
          const bufferArray = e.target.result
          const wb = XLSX.read(bufferArray, { type: 'buffer' })
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          const data = XLSX.utils.sheet_to_json(ws)
          resolve(data)
        }

        fileReader.onerror = error => {
          reject(error)
        }
      })

      promise.then(d => {
        var temp = []
        for (var i = 0; i < d.length; i++) {
          var sap_id = d[i].student_number
          var first_name = d[i].first_name
          var last_name = typeof d[i].last_name !== 'undefined' ? d[i].last_name : ''
          var father_name = typeof d[i].middle_name !== 'undefined' ? d[i].middle_name : ''
          var mother_name = typeof d[i].mother_name !== 'undefined' ? d[i].mother_name : ''
          var phone_number1 = typeof d[i].phone_no_1 !== 'undefined' ? d[i].phone_no_1.toString() : ''
          var phone_number2 = typeof d[i].phone_no_2 !== 'undefined' ? d[i].phone_no_2.toString() : ''
          var district = typeof d[i].district !== 'undefined' ? d[i].district : ''
          var station =
            typeof d[i].city_different_from_postal_city !== 'undefined' ? d[i].city_different_from_postal_city : ''
          var city = typeof d[i].city !== 'undefined' ? d[i].city : ''
          var state = typeof d[i].state !== 'undefined' ? d[i].state : ''
          var postalCode = typeof d[i].postal_code !== 'undefined' ? d[i].postal_code : ''
          var sub_caste = typeof d[i].sub_caste !== 'undefined' ? d[i].sub_caste.toString() : ''
          var religion = typeof d[i].religion !== 'undefined' ? d[i].religion.toString() : ''
          var country = typeof d[i].country !== 'undefined' ? d[i].country.toString() : ''
          var dob = excelDateToJSDate(d[i].date_of_birth)
          var registration_date = excelDateToJSDate(d[i].registration_date)
          var house_number = typeof d[i].house_number !== 'undefined' ? d[i].house_number : ''
          var building_no = typeof d[i].building_no !== 'undefined' ? d[i].building_no : ''
          var address4 = typeof d[i].address_4 !== 'undefined' ? d[i].address_4 : ''
          var room_number = typeof d[i].room_or_appartment_number !== 'undefined' ? d[i].room_or_appartment_number : ''
          var floor_no = typeof d[i].floor_no !== 'undefined' ? d[i].floor_no : ''
          var street1 = typeof d[i].street_1 !== 'undefined' ? d[i].street_1 : ''
          var street2 = typeof d[i].street_2 !== 'undefined' ? d[i].street_2 : ''
          var street3 = typeof d[i].street_3 !== 'undefined' ? d[i].street_3 : ''
          var street5 = typeof d[i].street_5 !== 'undefined' ? d[i].street_5 : ''
          var gender = typeof d[i].gender !== 'undefined' ? d[i].gender : ''
          district = typeof d[i].district !== 'undefined' ? d[i].district : ''
          var station1 =
            typeof d[i].city_different_from_postal_city !== 'undefined' ? d[i].city_different_from_postal_city : ''
          city = typeof d[i].city !== 'undefined' ? d[i].city : ''
          state = typeof d[i].state !== 'undefined' ? d[i].state : ''
          country = typeof d[i].country !== 'undefined' ? d[i].country : ''
          var address =
            house_number +
            ' ' +
            building_no +
            ' ' +
            address4 +
            ' ' +
            room_number +
            ' ' +
            floor_no +
            ' ' +
            street1 +
            ' ' +
            street2 +
            ' ' +
            street3 +
            ' ' +
            street5 +
            ' ' +
            district +
            ' ' +
            station1 +
            ' ' +
            city +
            ' ' +
            state +
            ' ' +
            country
          var email = typeof d[i].e_mail_id !== 'undefined' ? d[i].e_mail_id : ''
          temp.push({
            sap_id: sap_id,
            first_name: first_name,
            last_name: last_name,
            father_name: father_name,
            mother_name: mother_name,
            dob: dob,
            degree: degree,
            course: course,
            year: year,
            email: email,
            phone_number1: phone_number1,
            phone_number2: phone_number2,
            address: address,
            district: district,
            postalCode: postalCode,
            station: station,
            city: city,
            state: state,
            country: country,
            sub_caste: sub_caste,
            religion: religion,
            registration_date: registration_date,
            previous_date: 'null',
            gender: gender,
          })
        }
        if (temp.length > 0) {
          setItems(temp)
        } else {
          setMessage('WRONG FORMAT OF EXCEL')
          setShowError(true)
        }
      })
    } catch (e) {
      setMessage('OOPPS ERROR')
      setShowError(true)
    }
  }

  function excelDateToJSDate(excelDate) {
    console.log("⚡️ ~ file: UploadData.js:165 ~ excelDateToJSDate ~ excelDate:", excelDate);
    try {
      var date = new Date(Math.round((excelDate.toString() - (25567 + 2)) * 86400 * 1000))
      console.log("⚡️ ~ file: UploadData.js:176 ~ excelDateToJSDate ~ date:", date);
      var converted_date = date.toISOString().split('T')[0]
      return converted_date
    } catch (error) {
      if(excelDate.includes('.')){
        let dateArr = excelDate.split(".");
        dateArr= dateArr.reverse(); 
        excelDate = dateArr.join("-");
        return excelDate
      }
      if(excelDate.includes('/')){
        let dateArr = excelDate.split("/");
const temp = dateArr[0];
dateArr[0] = dateArr[1];
dateArr[1] = temp;
        dateArr= dateArr.reverse(); 
        excelDate = dateArr.join("-");
        return excelDate
      }
      setMessage('Wrong Date Format, it should be DD/MM/YYYY')
      setShowError(true)
    }
  }

  function upload() {
    console.log('UPLOAD STARTED')
    setIsLoading(true)
    const FirebaseApp = initializeApp(firebaseConfig)
    const db = getDatabase(FirebaseApp)
    uploadToDb(0, db)
  }

  function uploadToDb(index, db) {
    if (index === items.length) {
      setItems([])
      setIsLoading(false)
      setShow(true)
      return
    } else {
      let value = items[index]
      set(ref(db, 'student_data/' + value.sap_id), value)
        .then(() => {
          uploadToDb(index + 1, db)
        })
        .catch(error => {
          console.log(error)
          setIsLoading(false)
          setMessage('SOME ERROR OCCURED')
          setShowError(true)
          return
        })
    }
  }

  /*{
          sap_id: sap_id,
          first_name: first_name,
          last_name: last_name,
          father_name: father_name,
          mother_name: mother_name,
          dob: dob,
          course: course,
          year: year,
          email: email,
          phone_number1: phone_number1,
          phone_number2: phone_number2,
          address: address,
          district: district,
          postalCode: postalCode,
          station: station,
          city: city,
          state: state,
          country: country,
          sub_caste: sub_caste,
          religion: religion,
          registration_date: registration_date,

      }*/

  function resetForm() {
    setItems([])
    document.getElementById('form').reset()
  }

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
        <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide bg="success">
          <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>Successfully uploaded!</Toast.Body>
        </Toast>
      </div>

      <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
        <Toast onClose={() => setShowError(false)} show={showError} delay={3000} autohide bg="danger">
          <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>{message}</Toast.Body>
        </Toast>
      </div>

      <Navbars type={'1'} />
      <br />
      <br />
      <br />
      <center>
        <Form id="form" style={{ border: '1px black solid', width: '50%' }}>
          <br />
          <br />

          <Form.Group className="mb-3">
            <Form.Label style={{ marginRight: '5px' }}>DEGREE</Form.Label>
            <Form.Select
              value={degree}
              onInput={event => {
                setDegree(event.target.value)
              }}
            >
              <option value="B Tech">B Tech</option>
              <option value="BE">BE</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ marginRight: '5px' }}>BRANCH</Form.Label>
            <Form.Select
              value={course}
              onInput={event => {
                setCourse(event.target.value)
              }}
            >
              <option value="Information Technology">Information Technology</option>
              <option value="Computer engineering">Computer engineering</option>
              <option value="Computer Science and Engineering (Data Science)">
                Computer Science and Engineering (Data Science)
              </option>
              <option value="Computer Science and Engineering (IOT and Cyber Security with Block Chain Technology)">
                Computer Science and Engineering (IOT and Cyber Security with Block Chain Technology)
              </option>
              <option value="Artificial Intelligence and Machine Learning">
                Artificial Intelligence and Machine Learning
              </option>
              <option value="Artificial Intelligence (AI) and Data Science">
                Artificial Intelligence (AI) and Data Science
              </option>
              <option value="Electronics and Telecommunication Engg">Electronics and Telecommunication Engg</option>
              <option value="Electronics engineering">Electronics engineering </option>
              <option value="Mechanical engineering">Mechanical engineering</option>
              <option value="Production engineering">Production engineering</option>
              <option value="Biomedical engineering">Biomedical engineering</option>
              <option value="Chemical engineering">Chemical engineering</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label style={{ marginRight: '5px' }}>YEAR</Form.Label>
            <Form.Select
              value={year}
              onInput={event => {
                setYear(event.target.value)
              }}
            >
              <option value="1">FE</option>
              <option value="2">SE</option>
              <option value="3">TE</option>
              <option value="4">BE</option>
            </Form.Select>
          </Form.Group>

          <Form.Control
            type="file"
            onInput={e => {
              const file = e.target.files[0]
              readExcel(file)
            }}
            accept=".xlsx"
            placeholder="Select file"
            style={{ marginTop: '2%', width: '50%' }}
          />
          <br />
          <br />
          <Button
            onClick={() => {
              upload()
            }}
          >
            Upload
          </Button>
          <Button
            onClick={() => {
              resetForm()
            }}
            style={{ marginLeft: '5%' }}
          >
            Reset
          </Button>
          <br />
          <br />
          <br />
        </Form>
      </center>

      {items.length > 0 ? (
        <div style={{ marginLeft: '1%' }}>
          <br />
          <br />
          <h4>Preview</h4>
          <br />
          <div>
            <table>
              <tbody>
                <tr>
                  <th>sap_Id</th>
                  <th>first_name</th>
                  <th>last_name</th>
                  <th>father_name</th>
                  <th>mother_name</th>
                  <th>degree</th>
                  <th>course</th>
                  <th>year</th>
                  <th>dob</th>
                  <th>email</th>
                  <th>phone_no_1</th>
                  <th>phone_no_2</th>
                  <th>address</th>
                  <th>district</th>
                  <th>postal_code</th>
                  <th>station</th>
                  <th>city</th>
                  <th>state</th>
                  <th>country</th>
                  <th>sub_caste</th>
                  <th>religion</th>
                  <th>registration_date</th>
                  <th>gender</th>
                </tr>

                {items.map(value => {
                  return (
                    <tr key={uuid()}>
                      <td>{value.sap_id}</td>
                      <td>{value.first_name}</td>
                      <td>{value.last_name}</td>
                      <td>{value.father_name}</td>
                      <td>{value.mother_name}</td>
                      <td>{value.course}</td>
                      <td>{value.year}</td>
                      <td>{value.dob}</td>
                      <td>{value.email}</td>
                      <td>{value.phone_number1}</td>
                      <td>{value.phone_number2}</td>
                      <td>{value.address}</td>
                      <td>{value.district}</td>
                      <td>{value.postalCode}</td>
                      <td>{value.station}</td>
                      <td>{value.city}</td>
                      <td>{value.state}</td>
                      <td>{value.country}</td>
                      <td>{value.sub_caste}</td>
                      <td>{value.religion}</td>
                      <td>{value.registration_date}</td>
                      <td>{value.gender}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <br />
          <br />
          <div />
        </div>
      ) : null}
    </div>
  )
}
export default UploadData
